import { INVITE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE } from '@/common/actions/create';
import { GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES_NEW } from '@/common/actions/get';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@apollo/client';
import { Box, Button, Input, Modal, TextField } from '@servicepipe/ui-components';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

const FORM_ID = 'invite-user-form';

const validationSchema = Yup.object({
  email: Yup.string().required('The field is required').email('Email address must be valid'),
});

export const ModalInviteUser = ({ isShow, onToggle, onRefetch }) => {
  const { id: partnerClientAccountId } = useParams();
  const defaultValues = { email: '' };

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
  } = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  });

  const email = watch('email');

  const handleClose = () => {
    onToggle();
    reset(defaultValues);
  };

  const [inviteMember, { loading }] = useMutation(INVITE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE, {
    refetchQueries: [GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEES_NEW],
    awaitRefetchQueries: true,
    onCompleted: () => {
      handleClose();
      onRefetch?.();
      toast.success('Success');
    },
    onError: (error) => toast.error(error.message),
  });

  if (!isShow) {
    return null;
  }

  return (
    <Modal
      enableMaximize={false}
      size="s"
      title="Invite user"
      toggle={handleClose}
      closeOnClickOutside={!email}
      footer={
        <Box display="flex" justify="flex-end" gap="8px" width="100%" padding="0 8px">
          <Button
            isDisabled={loading}
            variant="outline"
            color="neutral"
            type="button"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            isDisabled={loading}
            isLoading={loading}
            variant="solid"
            color="accent"
            type="submit"
            form={FORM_ID}
          >
            Invite user
          </Button>
        </Box>
      }
    >
      <form
        id={FORM_ID}
        style={{ width: '100%' }}
        onSubmit={handleSubmit((formData) =>
          inviteMember({
            variables: {
              email: formData.email,
              id: Number(partnerClientAccountId),
            },
          })
        )}
      >
        <Box direction="column" gap="16px" width="100%">
          <Controller
            name="email"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="email"
                label="Email"
                isError={Boolean(errors?.email)}
                helperText={errors?.email?.message || ''}
              >
                <Input
                  width="100%"
                  type="email"
                  onChange={onChange}
                  value={value}
                  placeholder="username@example.com"
                />
              </TextField>
            )}
          />
        </Box>
      </form>
    </Modal>
  );
};
